import React, { Component } from 'react';
import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';
import { Card, CardBody, Row } from 'reactstrap';
import { CustomField } from '../../lib/components/react/react-jsonschema-form/customFormInput';
import { TextInput } from '../../lib/components/textInput';
import { TextInputPassword } from '../../lib/components/textInputPassword';
import { SizeMe } from 'react-sizeme';

/* React Confirm Alert */
import { ioteraConfirmAlert } from '../../lib/components/react/react-confirm-alert';

/* Routes */
import { domainIsTenant as dit, S } from '../../routes/routes'

/* React Router */
import { withRouter } from 'react-router-dom'

/* Result */
import Result from 'iotera-base/result'

/* Redux */
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../redux/ducks'
import { actions as notificationActions } from '../../redux/ducks/notification'
import { actions as modalActions } from '../../redux/ducks/modal'
import { actions as loadingActions } from '../../redux/ducks/loading'

/* Object Json */
import { isEmpty, isNone } from 'iotera-base/object';
import { safeDeepGet, safeDeepGetWithType } from 'iotera-base/json'

import './style.scss';
import { SubViewHeader } from '../../lib/components/subHeader';
import { IoteraForm } from '../../lib/components/form';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../lib/components/callbackGlobal';

const INIT_USER = 'INIT_USER';
const INIT_ROLES = "INIT_ROLES";
const EDIT = "EDIT";
const WKEY = 'USER';
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

const onError = (errors) => console.log("Ada", errors.length, "error yang harus diperbaiki");

// validation for string
function accessValidation(access) {
  let dropdownItem = [];
  for (let i = 0; i < access.length; i++) {
    dropdownItem.push(
      {
        type: 'string',
        enum: [
          access[i].id
        ],
        title: access[i].name
      }
    )
  }
  return dropdownItem;
}

function schema(access) {
  return {
    "definitions": {
      "Roles": {
        "title": "Role",
      }
    },
    type: "object",
    required: ["username", "first", "email", "role_id"],
    properties: {
      username: { type: "string", minLength: 4, maxLength: 16 },
      first: { type: "string", minLength: 4, maxLength: 16 },
      last: { type: "string", maxLength: 16 },
      email: { type: "string", minLength: 4 },
      role_id: {
        "type": "string",
        "anyOf": accessValidation(access),
        "title": "Role"
      },
    }
  }
};

const uiSchema = {
  username: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="username"
          type="text"
          label="Username"
          placeholder="iotera_team"
          textTooltip="Masukkan username untuk login pengguna"
          className="custom"
          value={props.value}
          disabled='disabled'
          onError={onError}
          required={props.required}
          onChange={event => props.onChange(event.target.value)} />
      )
    },
    "ui:options": {
      label: false
    }
  },
  first: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="first"
          type="text"
          label="Nama Depan"
          placeholder="Nama Depan"
          textTooltip="Masukkan nama depan pengguna"
          className="custom"
          value={props.value}
          onError={onError}
          required={props.required}
          onChange={event => props.onChange(event.target.value)} />
      )
    },
    "ui:options": {
      label: false
    }
  },
  last: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="last"
          type="text"
          label="Nama Belakang"
          placeholder="Nama Belakang"
          textTooltip="Masukkan nama belakang pengguna pengguna"
          className="custom"
          value={props.value}
          onError={onError}
          required={props.required}
          onChange={event => props.onChange(event.target.value)} />
      )
    },
    "ui:options": {
      label: false
    }
  },
  email: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="email"
          type="text"
          label="Alamat Email"
          placeholder="username@org.com"
          textTooltip="Masukkan alamat email dari pengguna"
          value={props.value}
          onError={onError}
          required={props.required}
          onChange={event => props.onChange(event.target.value)}
        />
      )
    },
    "ui:options": {
      label: false
    }
  },
  password: {
    "ui:widget": (props) => {
      return (
        <TextInputPassword
          id="password"
          type="text"
          label="Password"
          placeholder="********"
          textTooltip="Masukkan password untuk pengguna ini"
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)}
        />
      )
    },
    "ui:options": {
      label: false
    }
  },
  passwordConfirm: {
    "ui:widget": (props) => {
      return (
        <TextInputPassword
          id="passwordConfirm"
          type="text"
          label="Password"
          placeholder="********"
          textTooltip="Ketik ulang password diatas untuk konfirmasi."
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)}
        />
      )
    },
    "ui:options": {
      label: false
    }
  },
};

class User extends Component {
  constructor(props) {
    super(props);
    let widthImage;
    let paddingStyle = '6px 8px';
    if (window.innerWidth >= 768) {
      if (window.innerWidth >= 1200) {
        paddingStyle = '12px 16px';
        widthImage = '60%';
      } else {
        widthImage = '80%';
      }
    } else {
      widthImage = '50%';
    }
    this.toggle = this.toggle.bind(this);
    const userId = safeDeepGet(this, ['props', 'match', 'params', 'id']);
    this.state = {
      file: 'https://i.imgur.com/8FWamdx.jpg',
      activeTab: '1',
      custom: window.innerWidth <= 768 ? "col-sm-6" : "col-sm-12",
      formData: { username: "ioterateam" },
      loading: true,
      percent: window.innerWidth >= 768 ? '30%' : '80%',
      widthImage,
      userId,
      paddingStyle
    };
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.resize = this.resize.bind(this);
    this.onRemovePicture = this.onRemovePicture.bind(this);
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    const { userId } = _state;
    if (isNone(userId)) {
      return;
    }
    const wsKey = WKEY + '_' + userId;
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props)
    // Get dashboard
    _props.wInitRequestCall(
      {
        requests: {
          [INIT_USER]: {
            wparam: { ...domainIsTenant, path: '/service/web/application/account/manage/get/id/' + userId },
            wcallback: {
              started: function (id) {
                _props.showLoading();
              },
              finished: function (id, result) {
                if (result['code'] === 200) {
                  _this.setState({ loading: false })
                }
                _props.hideLoading();
              }
            }
          },
          [INIT_ROLES]: {
            wparam: { ...domainIsTenant, path: '/service/web/application/account/role/list' },
            wcallback: {
              started: function (id) {
                // TODO Loading
              },
              finished: function (id, result) {
                // TODO Loading
              }
            }
          }
        }
      }
    );
    _props.wSetConfig({
      single_config: {
        [EDIT]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/application/account/manage/edit"
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {

                  _this.setState({
                    loading: false
                  })
                  _props.history.push('..' + S + '_user_list_')
                  _props.showSingleNotification({ message: 'Edit User Sukses', level: 'success' });
                  return;
                }
              }
              _this.setState({
                loading: false
              })
              _props.showSingleNotification({ message: 'Edit User Gagal', position: 'tr', level: 'error' });
            }
          }
        }
      }
    });
  }

  componentWillUnmount() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    const { userId } = _state;
    if (isNone(userId)) {
      return;
    }
    // callback global
    unsetCallbackGlobal(_props)
    _props.wUnsetConfig({ key: WKEY });
  }

  resize(event) {
    let widthImage;
    let paddingStyle = '6px 8px';
    if (window.innerWidth >= 768) {
      if (window.innerWidth >= 1200) {
        paddingStyle = '12px 16px';
        widthImage = '60%';
      } else {
        widthImage = '80%';
      }
    } else {
      widthImage = '50%';
    }
    this.setState({
      custom: window.innerWidth <= 768 ? "col-sm-6" : "col-sm-12",
      percent: window.innerWidth >= 768 ? '30%' : '80%',
      widthImage,
      event,
      paddingStyle
    })
  }

  handleChange(event) {
    if (event.target.files.length > 0) {
      this.setState({
        file: URL.createObjectURL(event.target.files[0])
      })
    }
  }

  handleSubmit(event) {
    const _this = this;
    const _props = _this.props
    let submitData = event['formData'];
    const email = submitData['email'];
    const first = submitData['first'];
    const last = submitData['last'];
    const roleId = submitData['role_id'];
    const id = _props.userId;
    _this.setState({
      loading: true
    })
    const wsKey = WKEY + '_' + id;
    _props.wSingleRequestCall({
      id: EDIT,
      body: {
        id,
        email,
        first,
        last,
        role_id: roleId
      }
    });
  }
  getFiles(files) {
    this.setState({ files: files })
  }

  toggle(tab) {
    const _this = this;
    const _state = _this.state
    if (_state.activeTab !== tab) {
      _this.setState({
        activeTab: tab
      });
    }
  }

  goTo(link) {
    this.props.history.push(link)
  }

  onRemovePicture() {
    ioteraConfirmAlert(
      null,
      'Apakah anda yakin ingin menghapus gambar ini?',
      'Ya, hapus',
      () => this.setState({
        file: 'https://i.imgur.com/8FWamdx.jpg'
      }),
      null,
      null
    )
  }

  render() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    window.onresize = _this.resize;
    const { loading, paddingStyle } = _state;
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    let dataToShow = {};
    let items = safeDeepGetWithType(_props, ['items'], {});
    let access = safeDeepGetWithType(_props, ['access'], []);
    if (!isEmpty(items)) {
      dataToShow = items
    }
    return (
      <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
        <div className="view">
          <SubViewHeader title='Ubah Pengguna' subTitle='Permohonan ubah pengguna' />
          <div className="io-container mt-12">
            <Row style={{ margin: 0 }}>
              <div className="col-md-4"  >
                <SizeMe >{({ size }) =>
                  <Card className="cobaForm" style={{
                    minWidth: _state.widthImage, maxWidth: _state.widthImage,
                    height: size.width * 4 / 4, maxHeight: size.width * 4 / 4, border: '5px solid white',
                    boxShadow: '5px 5px 5px rgba(0, 0, 0, 0.25)', borderRadius: '50%'
                  }}>
                    <CardBody style={{ margin: 20 }}>
                      <div className="containers" style={{ position: 'absolute', top: 0, left: 0, bottom: 0, right: 0 }}>
                        <Card className="cardssss" style={{ backgroundColor: '#ffffff', mindWidth: '100%', minHeight: '100%' }}>
                          <CardBody >
                            <Row >
                              <img src={_state.file} alt="Profile" style={{
                                minHeight: '100%', maxHeight: '100%', minWidth: '100%',
                                position: 'absolute', top: 0, left: 0, bottom: 0, right: 0
                              }} />
                            </Row>
                          </CardBody>
                        </Card>
                        {_state.file === 'https://i.imgur.com/8FWamdx.jpg' ?
                          <div className="middle">
                            <Row >
                              <div className="col-md-12">
                                <label className="button-iotera-primary-outline text" style={{ padding: paddingStyle, marginBottom: 0 }}>
                                  <input type="file" accept="image/*" required onChange={_this.handleChange} />
                                  <span>Unggah</span>
                                </label>
                              </div>
                            </Row>
                          </div> :
                          <div className="middle">
                            <Row style={{ marginBottom: 5 }}>
                              <div className="col-md-12">
                                <label className="button-iotera-primary-outline text" style={{ padding: paddingStyle, marginBottom: 0 }}>
                                  <input type="file" accept="image/*" required onChange={_this.handleChange} />
                                  <span>Ganti</span>
                                </label>
                              </div>
                            </Row>
                            <Row>
                              <div className="col-md-12">
                                <button className="button-iotera-red-outline text" style={{ padding: paddingStyle, marginBottom: 0 }}
                                  onClick={(e) => _this.onRemovePicture()} >
                                  Hapus
                                </button>
                              </div>
                            </Row>
                          </div>
                        }
                      </div>
                    </CardBody>
                  </Card>}
                </SizeMe>
              </div>
              <div className="col-md-8"  >
                {access.length > 0 ?
                  <IoteraForm
                    schema={schema(access)}
                    uiSchema={uiSchema}
                    onSubmit={_this.handleSubmit}
                    FieldTemplate={CustomField}
                    formData={dataToShow}
                  >

                    <div className="button-right" style={{ marginTop: 10 }}>
                      <button className="button-iotera-white" type="button" style={{ minWidth: '0%' }}
                        onClick={(e) => _this.goTo('..' + S + '_user_list_')}>Batal</button>
                      <button className="button-iotera-primary" type="submit" style={{ marginLeft: 10, minWidth: '0%' }}>Simpan</button>
                    </div>
                  </IoteraForm>
                  : null}
              </div>
            </Row>
          </div>
        </div>
      </Loader>
    );
  }
}

const mapStateToProps = function (state) {
  let data = wSelector.getMappedState(state)
  return {
    items: wSelector.getRPayloadFromMappedState(data, INIT_USER),
    userId: wSelector.getMappedRPayload(state, INIT_USER, 'id'),
    access: wSelector.getMappedRPayload(state, INIT_ROLES, 'roles')
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch),
    ...bindActionCreators(modalActions, dispatch),
    ...bindActionCreators(loadingActions, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(User));